import { NO_PREMIUM_OPTIONS } from '@griply/hooks';
import { LimitKeys } from '@griply/types';
import { usePremiumFeatureAllowed } from 'shared/hooks/use-premium-feature-allowed';

export const useTwoWaySyncAllowed = () =>
  usePremiumFeatureAllowed(LimitKeys.TwoWayCalendarSync, NO_PREMIUM_OPTIONS);
